function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
;
(function (window, undefined) {
  const ALL_CALLBACKS = '*';
  const define = Object.defineProperties;
  const entries = Object.entries;
  const on = (callbacks, el) => (event, fn) => {
    if (callbacks.has(event)) {
      callbacks.get(event).add(fn);
    } else {
      callbacks.set(event, new Set().add(fn));
    }
    return el;
  };
  const deleteCallback = (callbacks, el, event, fn) => {
    if (fn) {
      const fns = callbacks.get(event);
      if (fns) {
        fns.delete(fn);
        if (fns.size === 0) callbacks.delete(event);
      }
    } else callbacks.delete(event);
  };
  const off = (callbacks, el) => (event, fn) => {
    if (event === ALL_CALLBACKS && !fn) {
      callbacks.clear();
    } else {
      deleteCallback(callbacks, el, event, fn);
    }
    return el;
  };
  const one = (callbacks, el) => (event, fn) => {
    function on() {
      el.off(event, on);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      fn.apply(el, args);
    }
    return el.on(event, on);
  };
  const trigger = (callbacks, el) => function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const fns = callbacks.get(event);
    if (fns) fns.forEach(fn => fn.apply(el, args));
    if (callbacks.get(ALL_CALLBACKS) && event !== ALL_CALLBACKS) {
      el.trigger(ALL_CALLBACKS, event, ...args);
    }
    return el;
  };
  const observable = function (el) {
    // eslint-disable-line
    const callbacks = new Map();
    const methods = {
      on,
      off,
      one,
      trigger
    };
    el = el || {};
    define(el, entries(methods).reduce((acc, _ref) => {
      let _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        method = _ref2[1];
      acc[key] = {
        value: method(callbacks, el),
        enumerable: false,
        writable: false,
        configurable: false
      };
      return acc;
    }, {}));
    return el;
  };
  /* istanbul ignore next */
  // support CommonJS, AMD & browser
  if (typeof exports === 'object') module.exports = observable;else if (typeof define === 'function' && define.amd) define(function () {
    return observable;
  });else window.observable = observable;
})(typeof window != 'undefined' ? window : undefined);